import {
  CalendarIcon,
  FileTextIcon,
  MapPinnedIcon,
  MessageCircleIcon,
  WarehouseIcon,
} from 'lucide-react';

import type { AsnDTO } from '@invenco/supply-interface';

import { AddressDisplay } from '@/components/address-display/address-display';
import { DetailList } from '@/components/detail-list';
import { formatDate } from '@/shared/helpers';

type Props = {
  asn?: AsnDTO;
  isLoading?: boolean;
};

export function AsnDetailsSection({ asn, isLoading }: Props) {
  return (
    <DetailList
      title="Details"
      isLoading={isLoading}
      items={[
        { icon: WarehouseIcon, label: 'Warehouse', value: asn?.locationName },
        {
          icon: CalendarIcon,
          label: 'Expected',
          value: asn?.expectedAt ? formatDate(asn.expectedAt) : undefined,
        },
        ...(asn?.arrivedAt
          ? [{ icon: CalendarIcon, label: 'Arrived', value: formatDate(asn.arrivedAt) }]
          : []),
        ...(asn?.closedAt
          ? [{ icon: CalendarIcon, label: 'Closed', value: formatDate(asn.closedAt) }]
          : []),
        {
          icon: MapPinnedIcon,
          label: 'From address',
          value: <AddressDisplay address={asn?.fromAddress} isLoading={isLoading} />,
        },
        {
          icon: FileTextIcon,
          label: 'Reference',
          value: asn?.reference ? (
            <span className="whitespace-pre-wrap">{asn.reference}</span>
          ) : undefined,
        },
        {
          icon: MessageCircleIcon,
          label: 'Notes',
          value: asn?.note ? <span className="whitespace-pre-wrap">{asn.note}</span> : undefined,
        },
      ]}
    />
  );
}
